// Define the base URL for assets. You could directly use '/imageName.png' if your app is hosted at the domain root.
const ASSET_URL = process.env.PUBLIC_URL;

export const IMAGES = {
  lilikoi: `${ASSET_URL}/lilikoi_medium.png`,
  passionfruit: `${ASSET_URL}/passionfruit.png`,
  dextools: `${ASSET_URL}/dextools.svg`,
};
